module.exports = __webpack_public_path__ + "img/Övriga tak.02f067d6.png";